module.exports = "/legacy/0e89df3d31af3920ba4e0c901b176de9.png";